import { render, staticRenderFns } from "./LivesDialog.vue?vue&type=template&id=6049bd1c"
import script from "./LivesDialog.vue?vue&type=script&lang=js"
export * from "./LivesDialog.vue?vue&type=script&lang=js"
import style0 from "./LivesDialog.vue?vue&type=style&index=0&id=6049bd1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports